export default "<p>fixedassetnewreq works!</p>\n"